import {Paper} from '@material-ui/core';
import React from 'react';
import CardField from 'Shared/components/CardField';
import withUserClaims, {WithClaimsProps} from 'Shared/components/withUserClaims';
import {UserProfilePayload} from 'Users/models/UserProfilePayload';
import './EmployeeUserInformationSection.sass';

type EmployeeUserInformationSectionProps = WithClaimsProps & {
  profile: UserProfilePayload;
  showPosition: boolean;
};

const EmployeeUserInformationSection = (props: EmployeeUserInformationSectionProps) => {
  return (
    <Paper className="employee-user-information">
      <CardField name="User Name" value={props.claims.userName} />
      <CardField name="First Name" value={props.claims.firstName} />
      <CardField name="Last Name" value={props.claims.lastName} />
      <CardField name="Email" value={props.profile.email} />
      {props.showPosition && <CardField name="Position" value={props.profile.position} />}
    </Paper>
  );
};

export default withUserClaims(EmployeeUserInformationSection);
